import { useContext } from 'react';
import { Grid, Typography, TextField, MenuItem, IconButton } from '@mui/material';
import { IoPersonAddOutline as AddPersonIcon, IoBusinessSharp as SimecUserIcon, IoPersonOutline as CustomerUserIcon } from 'react-icons/io5';
import { localeManagerContext } from 'helpers/Locale';
import { appUserContext, applicationContext } from 'helpers/services';
import { EditIconButton, TicketSource } from 'components';
import { ticketDetailsContext } from '../../TicketDetailsContext';
import CreateReporter from './CreateReporter';
import EditTicket from './EditTicket';
import moment from 'moment';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import BaseInfoOrders from './BaseInfoOrders';
import { Autocomplete } from '@mui/material';
import { TicketPriority, TicketStatus } from 'helpers/Enums';


let BaseInfo = () => {
    let { formatMessage } = useIntl();
    let appService = useContext(applicationContext);
    let { currentUser } = useContext(appUserContext);
    let { currentLocale } = useContext(localeManagerContext);

    let service = useContext(ticketDetailsContext);


    return (
        <div style={{ backgroundColor: '#efefef' }}>
            <Grid container alignItems="center">
                <Grid item xs>
                    <Typography variant="subtitle2" style={{ color: 'rgb(183, 0, 5)' }}>
                        <b>{formatMessage({ id: LocalizationIds.Details }).toUpperCase()}</b>
                    </Typography>
                </Grid>
                <Grid item>
                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                        <EditIconButton onClick={() => service.openEditDialogHandler()} />
                    }
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} md={6}>
                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                        <TextField
                            select
                            label={formatMessage({ id: LocalizationIds.Status })}
                            value={service.ticket.status}
                            name="status"
                            onChange={(e: any) => service.updateTicketStatus(e.target.value as any as TicketStatus)}
                        >
                            {appService.ticketStatuses.map(status =>
                                <MenuItem key={status.code} value={status.code}>{status.descriptions[currentLocale]}</MenuItem>
                            )}
                        </TextField>
                    }
                    {(service.ticket.isReadOnly === true || currentUser.simecClaims.canWorkOnMyTickets === true) &&
                        <>
                            <Typography variant="subtitle2">
                                <b>{formatMessage({ id: LocalizationIds.Status })}</b>
                            </Typography>
                            <Typography variant="body1">
                                {appService.ticketStatuses.find(f => f.code === service.ticket.status)?.descriptions[currentLocale] || service.ticket.status}
                            </Typography>
                        </>
                    }
                </Grid>
                <Grid item xs={12} md={6}>
                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                        <TextField
                            select
                            label={formatMessage({ id: LocalizationIds.Category })}
                            value={service.ticket.ticketSubCategoryId}
                            name="ticketSubCategoryId"
                            onChange={(e) => {
                                service.updateTicketSubCategory(
                                    e.target.value as any as TicketPriority
                                );
                            }}
                        >
                            {appService.ticketSubCategories.map(subcategory =>
                                <MenuItem key={subcategory.id} value={subcategory.id}>{subcategory.categoryNames[currentLocale]} / {subcategory.names[currentLocale]}</MenuItem>
                            )}
                        </TextField>
                    }
                    {(service.ticket.isReadOnly === true || currentUser.simecClaims.canWorkOnMyTickets === true) &&
                        <>
                            <Typography variant="subtitle2">
                                <b>{formatMessage({ id: LocalizationIds.Category })}</b>
                            </Typography>
                            {appService.ticketSubCategories.findIndex(f => f.id === service.ticket.ticketSubCategoryId) >= 0 &&
                                <Typography variant="body1">
                                    {appService.ticketSubCategories.find(f => f.id === service.ticket.ticketSubCategoryId)?.categoryNames[currentLocale]} /&nbsp;
                                    {appService.ticketSubCategories.find(f => f.id === service.ticket.ticketSubCategoryId)?.names[currentLocale]}
                                </Typography>
                            }
                        </>
                    }
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} md>
                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                        <TextField
                            select
                            label={formatMessage({ id: LocalizationIds.Priority })}
                            value={service.ticket.priority}
                            name="priority"
                            onChange={(e: any) => service.updateTicketPriority(e.target.value)}
                        >
                            {appService.ticketPriorities.map(priority =>
                                <MenuItem key={priority.key} value={priority.key}>{priority.value}</MenuItem>
                            )}
                        </TextField>
                    }
                    {(service.ticket.isReadOnly === true || currentUser.simecClaims.canWorkOnMyTickets === true) &&
                        <>
                            <Typography variant="subtitle2">
                                <b>{formatMessage({ id: LocalizationIds.Priority })}</b>
                            </Typography>
                            <Typography variant="body1">{appService.ticketPriorities.getValueByKey(service.ticket.priority) || service.ticket.priority}</Typography>
                        </>
                    }
                </Grid>
                <Grid item xs={12} md>
                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                        <TextField
                            select
                            label={formatMessage({ id: LocalizationIds.ShareTicketWithTheCustomer })}
                            value={service.ticket.customerCanView}
                            name="customerCanView"
                            disabled={appService.ticketSubCategories.find(f => f.id === service.ticket.ticketSubCategoryId)?.canBeSelectedByCustomer !== true}
                            onChange={(e) => service.updateTicketCustomerCanView(e.target.value === 'true')}
                        >
                            <MenuItem value={'true'}>{formatMessage({ id: LocalizationIds.Yes })}</MenuItem>
                            <MenuItem value={'false'}>{formatMessage({ id: LocalizationIds.No })}</MenuItem>
                        </TextField>
                    }
                    {(service.ticket.isReadOnly === true || currentUser.simecClaims.canWorkOnMyTickets === true) &&
                        <>
                            <Typography variant="subtitle2">
                                <b>{formatMessage({ id: LocalizationIds.SharedWithCustomer })}</b>
                            </Typography>
                            <Typography variant="body1">
                                {service.ticket.customerCanView ? formatMessage({ id: LocalizationIds.Yes }) : formatMessage({ id: LocalizationIds.No })}
                            </Typography>
                        </>
                    }
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs md>
                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                        <Autocomplete
                            value={service.ticket.reporterUserName}
                            onChange={(e, newValue) => service.updateTicketReporterUserName(newValue || "")}
                            getOptionLabel={(option) => service.reporters.getValueByKey(option, 'value', 'label')}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(muiProps, option) => (
                                <li {...muiProps}>
                                    {service.reporters.getValueByKey(option, 'value', 'isExternal') === true && <CustomerUserIcon />}
                                    {service.reporters.getValueByKey(option, 'value', 'isExternal') === false && <SimecUserIcon />}
                                    {<>&nbsp;{service.reporters.getValueByKey(option, 'value', 'label')}</>}
                                </li>
                            )}
                            options={service.reporters.map(x => x.value)}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label={formatMessage({ id: LocalizationIds.Reporter })}
                                />
                            }
                        />
                    }
                    {(service.ticket.isReadOnly === true || currentUser.simecClaims.canWorkOnMyTickets === true) &&
                        <>
                            <Typography variant="subtitle2"><b>{formatMessage({ id: LocalizationIds.Reporter })}</b></Typography>
                            <Typography variant="body1">{service.ticket.reporterUser || formatMessage({ id: LocalizationIds.NoOne })}</Typography>
                        </>
                    }
                </Grid>
                {service.ticket.isReadOnly === false
                    && currentUser.simecClaims.canWorkOnMyTickets === false
                    && currentUser?.simecClaims?.canManageCustomerUsers === true &&

                    <Grid item xs={2} md={1} style={{ verticalAlign: 'middle', display: 'flex' }}>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => service.openCreateReporter()}
                        >
                            <AddPersonIcon />
                        </IconButton>
                    </Grid>
                }
            </Grid>

            <Grid container>
                <Grid item xs={12} md={6}>
                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                        <TextField
                            select
                            label={formatMessage({ id: LocalizationIds.Groups })}
                            value={service.ticket.groups}
                            SelectProps={{ multiple: true }}
                            onChange={(e: any) => {
                                let currentAssignee = service.assignableUsers.find(x => x.email === service.ticket.assigneeUserName);

                                // se il ticket e' assegnato 
                                // l'assignee ha dei grouppi 
                                // l'assignee non può lavorare in tutti i tickets
                                // il grouppo che sto rimuovedndo e' uno dei gruppi dell' assignee

                                if (currentAssignee
                                    && currentAssignee.groups.length > 0
                                    && currentAssignee.canWorkOnAllTickets === false
                                    && !currentAssignee.groups.find(x => e.target.value.indexOf(x) !== -1)) {

                                    let text = "Removing this group will change the assignee";
                                    text += ` from '${currentAssignee.name}' `;
                                    text += "to 'Unassigned'. Do you want to proceed?";

                                    if (window.confirm(text)) {
                                        service.updateGroups(e.target.value || [])
                                    }
                                } else {
                                    service.updateGroups(e.target.value || [])
                                }

                            }}
                        >
                            {appService.userGroups
                                .map(group => <MenuItem key={group.key} value={group.key}>{group.value}</MenuItem>)
                            }
                        </TextField>
                    }
                    {(service.ticket.isReadOnly === true || currentUser.simecClaims.canWorkOnMyTickets === true) &&
                        <>
                            <Typography variant="subtitle2"><b>{formatMessage({ id: LocalizationIds.Groups })}</b></Typography>
                            <Typography variant="body1">
                                {appService.userGroups.filter(x => service.ticket.groups.indexOf(x.key) !== -1).length === 0 && formatMessage({ id: LocalizationIds.NoOne })}
                                {appService.userGroups
                                    .filter(x => service.ticket.groups.indexOf(x.key) !== -1)
                                    .map(x => x.value)
                                    .join(", ")
                                }
                            </Typography>
                        </>
                    }
                </Grid>
                <Grid item xs={12} md>
                    {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                        <Autocomplete
                            value={service.ticket.assigneeUserName}
                            isOptionEqualToValue={(option, value) => option === value}
                            onChange={(e, newValue) => service.updateTicketAssigneeUserName(newValue || '')}
                            getOptionLabel={(option) => service.assignableUsers.getValueByKey(option, "email", "name")}
                            options={service.assignableUsers.map(x => x.email)}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label={formatMessage({ id: LocalizationIds.AssignedTo })}
                                />
                            }
                        />
                    }
                    {(service.ticket.isReadOnly === true || currentUser.simecClaims.canWorkOnMyTickets === true) &&
                        <>
                            <Typography variant="subtitle2"><b>{formatMessage({ id: LocalizationIds.AssignedTo })}</b></Typography>
                            <Typography variant="body1">{service.ticket.assigneeUser || formatMessage({ id: LocalizationIds.NoOne })}</Typography>
                        </>
                    }
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="subtitle2" style={{ color: 'rgb(183, 0, 5)' }}>
                        <b>{formatMessage({ id: LocalizationIds.Activity }).toUpperCase()}</b>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2"><b>{formatMessage({ id: LocalizationIds.CreatedBy })}</b></Typography>
                    <Typography variant="body1">{service.ticket.createdByFullName}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2"><b>{formatMessage({ id: LocalizationIds.CreatedOn })}</b></Typography>
                    <Typography variant="body1">{moment(service.ticket.createdOn).format("DD/MM/YYYY")}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2"><b>{formatMessage({ id: LocalizationIds.Origin })}</b></Typography>
                    <Typography variant="body1"><TicketSource value={service.ticket.source} /></Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2"><b>{formatMessage({ id: LocalizationIds.LastUpdate })}</b></Typography>
                    <Typography variant="body1">{moment(service.ticket.lastUpdatedOn).format("DD/MM/YYYY")}</Typography>
                </Grid>
            </Grid>
            {service.selectedOrders.length > 0 &&
                <BaseInfoOrders />
            }

            {service.showEditDialog === true &&
                <EditTicket
                    onClose={(reloadTicket: boolean) => service.closeEditDialogHandler(reloadTicket)}
                    partialTicket={{
                        customerId: service.ticket.customerId,
                        customerName: service.ticket.customerName,
                        ticketId: service.ticket.ticketId,
                        title: service.ticket.title,
                        countryCode: service.ticket.countryCode,
                        countryName: service.ticket.countryName,
                        reporter:service.ticket.reporterUserName
                    }}
                />
            }
            {service.showCreateReporter === true &&
                <CreateReporter
                    ticketId={service.ticket.ticketId}
                    ticketCustomer={{
                        customerId: service.ticket.customerId,
                        customerName: service.ticket.customerName
                    }}
                    onClose={(refresh: boolean) => service.closeReporterDialogHandler(refresh)}
                />
            }
        </div>
    )
}

export default BaseInfo;